import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  main: {
    marginTop: '2rem',
  },
});

const Main = (props) => {
  const classes = useStyles();
  return <main className={classes.main} {...props} />;
};

export default Main;
